/**
 * White-Label Branding Configuration
 * 
 * This file controls all branding elements that can be customized
 * by white-label clients. 
 * 
 * HOW TO CUSTOMIZE:
 * 1. Set environment variables in frontend/.env
 * 2. Or edit the defaults below for your deployment
 */

const brandingConfig = {
  // App Name - Main brand name
  appName: process.env.REACT_APP_BRAND_NAME || 'FlowFeed',
  appNameArabic: process.env.REACT_APP_BRAND_NAME_AR || 'فلوفيد',
  
  // Tagline
  tagline: process.env.REACT_APP_TAGLINE || 'AI-Powered POS',
  taglineArabic: process.env.REACT_APP_TAGLINE_AR || 'نقاط بيع ذكية',
  
  // Company Info
  companyName: process.env.REACT_APP_COMPANY_NAME || 'FlowFeed',
  companyWebsite: process.env.REACT_APP_COMPANY_WEBSITE || 'https://flowfeederp.com',
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'support@flowfeederp.com',
  
  // Colors (CSS variables - can be overridden in index.css)
  primaryColor: process.env.REACT_APP_PRIMARY_COLOR || '#2563EB',
  accentColor: process.env.REACT_APP_ACCENT_COLOR || '#7C3AED',
  
  // Logo URLs (optional - defaults to built-in logo)
  logoUrl: process.env.REACT_APP_LOGO_URL || null,
  faviconUrl: process.env.REACT_APP_FAVICON_URL || '/favicon.svg',
  
  // Feature Flags for White-Label
  showPoweredBy: process.env.REACT_APP_SHOW_POWERED_BY !== 'false',
  showPublicPricing: process.env.REACT_APP_SHOW_PUBLIC_PRICING !== 'false',
  
  // Module Visibility - Control which modules appear in sidebar
  // Set to 'false' to hide specific modules for white-label
  modules: {
    masterAdmin: process.env.REACT_APP_MODULE_MASTER_ADMIN !== 'false',
    tenders: process.env.REACT_APP_MODULE_TENDERS !== 'false',
    aiVoice: process.env.REACT_APP_MODULE_AI_VOICE !== 'false',
    blogAdmin: process.env.REACT_APP_MODULE_BLOG_ADMIN !== 'false',
    pos: process.env.REACT_APP_MODULE_POS !== 'false',
    knowledgeBase: process.env.REACT_APP_MODULE_KNOWLEDGE_BASE !== 'false',
    appStore: process.env.REACT_APP_MODULE_APP_STORE !== 'false',
    zatca: process.env.REACT_APP_MODULE_ZATCA !== 'false',
    arabicLanguage: process.env.REACT_APP_MODULE_ARABIC !== 'false',
    aiVoiceApi: process.env.REACT_APP_MODULE_AI_VOICE_API !== 'false',
    generalSettings: process.env.REACT_APP_MODULE_GENERAL_SETTINGS !== 'false',
  },
  
  // Copyright
  copyrightYear: new Date().getFullYear(),
  get copyrightText() {
    return `© ${this.copyrightYear} ${this.companyName}. All rights reserved.`;
  }
};

// Helper functions
export const getBrandName = (isRTL = false) => {
  return isRTL ? brandingConfig.appNameArabic : brandingConfig.appName;
};

export const getTagline = (isRTL = false) => {
  return isRTL ? brandingConfig.taglineArabic : brandingConfig.tagline;
};

// Check if a module is enabled
export const isModuleEnabled = (moduleName) => {
  return brandingConfig.modules[moduleName] !== false;
};

export default brandingConfig;
